import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { IAppState } from '../../store/state';
import * as CoreActions from '../../store/actions';
import { selectToken } from '../../store/selectors';
import { NotificationService } from '../../services/notification/notification.service';

/**
 * 401 só significa "sessão expirou" quando a requisição levava o token da
 * SESSÃO já autenticada (o que o AuthInterceptor injeta a partir do store) —
 * réplica do mesmo cuidado descrito no ARQUITETURA.md do portal-cliente-frontend,
 * já que chamadas com o partnerToken (Administradora/Parametros*) também
 * mandam Authorization próprio sem o usuário estar logado.
 */
@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private store: Store<IAppState>, private notification: NotificationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) =>
        this.store.select(selectToken).pipe(
          take(1),
          switchMap((sessionToken) => {
            const authHeader = request.headers.get('Authorization');
            const isSessionRequest = !!sessionToken && authHeader === `Bearer ${sessionToken}`;
            if (error.status === 401 && isSessionRequest) {
              this.store.dispatch(CoreActions.signOut());
              this.notification.error('Você não está autenticado.');
            } else if (error.status === 0 || error.status >= 500) {
              this.notification.error('Não foi possível se comunicar com o servidor. Tente novamente.');
            }
            return throwError(() => error);
          })
        )
      )
    );
  }
}
